import type * as CANNON from 'cannon-es';
import type * as THREE from 'three';

/**
 * Game State Types
 * - loading: Game initialization in progress
 * - instructions: Pre-game instruction screen
 * - playing: Game in progress
 * - gameOver: Game ended
 */
export type GameState = 'loading' | 'instructions' | 'playing' | 'gameOver';

/**
 * Game Layer (Block) Interface
 * Manages Three.js mesh and Cannon.js body together
 */
export interface Layer {
  threejs: THREE.Mesh;
  cannonjs: CANNON.Body;
  width: number;
  depth: number;
  direction?: 'x' | 'z';
}

/**
 * Game Configuration Interface
 */
export interface GameConfig {
  /** Block color array (cycled through) */
  colors: string[];
  /** Speed settings */
  speed: {
    /** Base speed */
    base: number;
    /** Speed increment per block */
    increment: number;
    /** Maximum speed limit */
    max: number;
  };
  /** Background settings */
  background: {
    /** Background color (value for Three.js Color constructor) */
    color: string | number;
    /** Gradient background option (future extension) */
    gradient?: boolean;
  };
}

/**
 * Default Game Configuration
 */
export const DEFAULT_GAME_CONFIG: GameConfig = {
  colors: [
    '#FF6B6B',
    '#4ECDC4',
    '#45B7D1',
    '#FFA07A',
    '#98D8C8',
    '#F7DC6F',
    '#BB8FCE',
    '#85C1E9',
  ],
  speed: {
    base: 0.008,
    increment: 0.0005,
    max: 0.025,
  },
  background: {
    color: '#87CEEB',
  },
};
